
import { Component, Mixins, ActionButtonConfig, FormModalMixins, appConst, Watch } from "@/lib";
import ProductName from "@/store/modules/system/productname/entity";
@Component
export default class EditProductName extends Mixins(FormModalMixins) {
  model = new ProductName();

  private trimCode() {
    const code: any = this.model.code;
    if (typeof code === "string") {
      const trimmed = code.trim();
      if (trimmed !== code) this.model.code = trimmed;
    }
  }

  @Watch("model.code")
  onCodeChanged() {
    this.trimCode();
  }

  @Watch("config.isShow")
  onVisibleChanged(value: boolean) {
    if (!value) return;
    this.trimCode();
  }

  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit", labelWidth: 100, okAction: "system/productname/update" });
  }
  get record() {
    return this.$store.state.system.productname.editProductName;
  }
  get unitList() {
    return this.getCodeListByCategory(appConst.codeCategory.unit);
  }
}
